import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import CreateTermsAndConditionsForm from '../../../modules/termsAndConditions/components/CreateTermsAndConditionsForm';

const CreateTermsAndConditions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_terms_and_conditions') : t('create_terms_and_conditions');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/terms-and-conditions/create-terms-and-conditions' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateTermsAndConditionsForm />
    </div>
  );
};

export default CreateTermsAndConditions;
